
import { Injectable } from '@angular/core';
import { LoggerService } from './logger.service';

@Injectable({
    providedIn: 'root'
})
export class ConstantsService {

    constructor(private logger: LoggerService,) { }
    public regxAZazSpaceMinus: any = '^(?!\\s)[A-Za-z-\\s]+$';
    public emailPattern: any = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
    public emailPattern2: any = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$';
    // public emailPattern: any = '^(?!\\s)[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{3,})$';
    // /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    public pattern = /^[A-Za-zÀ-ÖØ-öø-ÿ0-9]+$/;
    public fnlnFrenchAndEnglishRegx = "^(?!\\s)[A-Za-zÀ-ÖØ-öø-ÿ0-9-.\\s]+$";
    public fnlnFrenchAndEnglishRegx1 = /^(?!\\s)[A-Za-zÀ-ÖØ-öø-ÿ0-9-.\\s]+$/;

    // public dobFormateRegex = "[0-9-]+$";
    public dobFormateRegex = "^[0-9]+(-[0-9]+)+$";


    fnValidate(inputValue: string, pattern: any) {
        if (!pattern.test(inputValue)) {
            return { 'fnlnFrenchAndEnglish': true };
        }
        return null;
    }

}